import { showMessage } from '../react/components/message';

const error = (message) => {
  console.error(message);
}

const info = (message) => {
  console.info(message);
}

export { error, info };
